<template>
    <v-card>
        <v-data-table
            :footer-props="{itemsPerPageOptions:[10,15,20]}"
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            class="elevation-0 dataTable pt-3"
        >
            <template
                v-slot:body.prepend="{ headers }"
            >
                <tr>
                    <td>
                        <v-text-field
                            v-model="hotelName"
                            label="Hotel..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()"
                        >
                        </v-text-field>
                    </td>
                    <td>
                        <v-select
                            class="mt-4"
                            v-model="active"
                            chips
                            :items="selects"
                            item-text="text"
                            item-value="value"
                            label="Situação do hotel"
                        ></v-select>
                    </td>
                    <td>
                        <v-menu
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    class="mt-5"
                                    v-model="date"
                                    label="Data..."
                                    persistent-hint
                                    prepend-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateCalendar"
                                range
                                no-title
                            ></v-date-picker>
                        </v-menu>
                    </td>
                    <td></td>
                    <td></td>
                    <td class="text-center" >
                        <v-btn
                            class="mt-4"
                            depressed
                            color="primary"
                            width="80%"
                            v-on:click="getData()"
                        >
                            Buscar
                        </v-btn>
                        <v-btn
                            class="mt-4 mb-4"
                            depressed
                            color="#FBC02D"
                            width="80%"
                            v-on:click="getCleanFilter()"
                        >
                            Limpar
                        </v-btn>
                    </td>
                </tr>
            </template>

            <template v-slot:item.hotelName="{ item }">
                {{ item.hotel.name }}
            </template>
            <template v-slot:item.active="{ item }">
                <v-chip v-if="item.hotel.active === 1"
                        class="ma-2"
                        color="green"
                        text-color="white"
                >
                    {{ getActive(item.hotel) }}
                </v-chip>
                <v-chip v-if="item.hotel.active === 0 "
                        class="ma-2"
                        color="red"
                        text-color="white"
                >
                    {{ getActive(item.hotel) }}
                </v-chip>
            </template>
            <template v-slot:item.changeType="{ item }">
                <v-chip
                    class="ma-2"
                    color="warning"
                    text-color="black"
                >
                    {{ translateChangeType(item.change_type) }}
                </v-chip>
            </template>
            <template v-slot:item.pendingChangeDate="{ item }">
                {{ parseDate(item.created_at, 'DD/MM/YYYY HH:mm') }}
            </template>
            <template v-slot:item.hotelPhone="{ item }">
                <div class="allPhonesContainer">
                    <div class="individualPhoneContainer" v-if="item.hotel.telephone">
                        <v-icon>mdi-phone</v-icon>
                         {{ item.hotel.telephone }}
                    </div>
                    <div v-if="item.hotel.whatsapp_number" class="individualPhoneContainer">
                        <v-icon>mdi-whatsapp</v-icon>
                         {{ item.hotel.whatsapp_number }}
                    </div>
                    <span v-if="!item.hotel.whatsapp_number && !item.hotel.telephone">Não cadastrado</span>
                </div>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-container>
                    <router-link :to="{name: 'editHotel', params: {id: item.hotel_id}}">
                        <v-btn
                            small
                            class="mr-2"
                            color="success"
                        >
                            Editar hotel
                        </v-btn>
                    </router-link>
                </v-container>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import moment from 'moment';
import ConfirmDeletionModal from "../Modals/ConfirmDeletionModal.vue";

export default {
    name: "ListHotelPendingChanges",
    components: {ConfirmDeletionModal},
    data: () => ({
        hotelName: '',
        changeType: '',
        changeDate: '',
        until: '',
        loading: true,
        total: 0,
        dateCalendar: [],
        date: '',
        active: '',
        selects: [
            {text: 'Ativo', value: '1' },
            {text: 'Inativo', value:'0'},
        ],
        options: {
            sortDesc: [true],
        },
        headers: [
            {text: 'Nome', value: 'hotelName'},
            {text: 'Situação do hotel', value: 'active', sortable: false},
            {text: 'Pedido de alteração', value: 'pendingChangeDate'},
            {text: 'Telefone do Hotel', value: 'hotelPhone', sortable: false, width: '15%'},
            {text: 'Alteração a ser feita', width: '10%', value: 'changeType', sortable: false},
            {text: 'Ações', value: 'actions', sortable: false},
        ],
        items: [],
    }),
    mounted () {
        if(Object.keys(this.$route.query).length) {
            const {
                sort,
                sortDesc,
                page,
                perPage,
                hotelName,
                active,
                changeType,
                changeDate,
                until,
            } = this.$route.query;
            if(sort) {
                this.options.sortBy = sort;
            }
            if(sortDesc) {
                this.options.sortDesc = sortDesc;
            }
            if(page) {
                this.options.page = parseInt(page ? page : 1);
            }
            if(perPage) {
                this.options.perPage = perPage;
            }
            if(hotelName) {
                this.hotelName = hotelName;
            }
            if(active) {
                this.active = active;
            }
            if(changeType) {
                this.changeType = changeType;
            }
            if(changeDate) {
                this.changeDate = changeDate;
            }
            if(until) {
                this.until = until;
            }
        }
    },
    methods: {
        translateChangeType(type) {
            if (type === 'telephoneWithoutAccount') {
               return 'Telefone sem conta WhatsApp';
            }

            if (type === 'invalidCnpj') {
                return 'CNPJ inválido';
            }
        },
        parseDate(date, format) {
            return moment(date).format(format);
        },
        formatDate (dateCalendar) {
            if (!dateCalendar) return null

            const [year, month, day] = dateCalendar.split('-')
            return `${day}/${month}/${year}`
        },
        getActive( item){
            if(item.active === 1){
                return "Ativo"
            }
            if(item.active === 0){
                return "Inativo"
            }
        },
        getCleanFilter(){
            this.$router.replace({'query': null});
            window.location.reload();
        },
        getData() {
            this.loading = true;
            const {sortBy, sortDesc, page, itemsPerPage} = this.options;
            const query = `sort=${sortBy}&sortDesc=${sortDesc}&page=${page}&perPage=${itemsPerPage}&hotelName=${this.hotelName}&active=${this.active}
                &changeType=${this.changeType}&changeDate=${this.changeDate}&until=${this.until}`;
            this.$router.push({
                query: {
                    sort: sortBy,
                    sortDesc: sortDesc,
                    page: page,
                    perPage: itemsPerPage,
                    hotelName: this.hotelName,
                    active: this.active,
                    changeType: this.changeType,
                    changeDate: this.changeDate,
                    until: this.until,
                }
            });

            axios.get(`api/hotel-pending-changes/list?${query}`)
                .then(res => {
                    this.items = res.data.data;
                    this.total = res.data.total;
                    this.loading = false;
                });
        },
    },
    watch: {
        options: {
            handler() {
                this.getData()
            },
            deep: true,
        },
        dateCalendar() {
            let changeDate= this.formatDate(this.dateCalendar[0])
            if (this.dateCalendar[1] != null ){
                let until= this.formatDate(this.dateCalendar[1])
                this.date= changeDate + " ate " + until
                this.changeDate = this.dateCalendar[0]
                this.until = this.dateCalendar[1]
            }
        },
    }
}
</script>

<style>
.dataTable {
    border-bottom: 1px solid rgba(0, 0, 0, .12);
    border-radius: 0;
}

.dataTable .v-data-table-header tr th span {
    font-size: 14px !important;
}

a {
    text-decoration: none;
}

.allPhonesContainer {
    display: flex;
    flex-direction: column;
    padding: 4px 0 4px 0;
}

.individualPhoneContainer {
    display: flex;
    padding: 2px;
}

.individualPhoneContainer i {
    margin-right: 3px;
}
</style>
